import axios from 'axios'
import Qs from 'qs'
import _ from 'lodash'
import { URL_PREFIX, URL_PREFIX_DEV } from '../utils/constants'
import Vue from 'vue'
import localStorage from './localstorage'
import { setupCache } from 'axios-cache-adapter'
const cache = setupCache({
    readHeaders: true,
  })
const http = axios.create({
    baseURL: `${URL_PREFIX}/panel`,
    useCredentials: true,
    adapter: cache.adapter,
})

const http_dev = axios.create({
    baseURL: `${URL_PREFIX_DEV}/panel`,
    useCredentials: true,
    adapter: cache.adapter,
})

http.interceptors.request.use(
    function (config) {
        const token = localStorage.get('token')
        if (token) config.headers.Authorization = `Bearer ${token}`
        return config
    },
    function (error) {
        return Promise.reject(error)
    },
)

http_dev.interceptors.request.use(
    function (config) {
        const token = localStorage.get('token')
        if (token) config.headers.Authorization = `Bearer ${token}`
        return config
    },
    function (error) {
        return Promise.reject(error)
    },
)

const mutateResponse = response => {
    if (typeof response.data !== 'string') {
        const data = response.data.data || response.data.response_data
        if (!data || (_.isArrayLikeObject(data) && _.isEmpty(data))) {
            console.log('Ingen data')
        }
    }
    return Promise.resolve(response)
}

const handleErrorResponse = (e, failSilently) => {
    if (e.message === 'cancelled') { return Promise.reject(e.message) }
    if (!failSilently) {
        var errors = ''

        if (e.response ? (e.response.data ? e.response.data.errors : null) : null) {
            _.each(e.response.data.errors, error => {
                errors += `${error[0]}\n\n`
            })
        }
        Vue.prototype.$toast(`${e}: ` + `\n\n${errors}`, { color: 'red' })
    }
    return Promise.reject(e)
}

const paramsSerializer = (params, mutateLocation) => {
    const stringiFiedParams = Qs.stringify(params, { arrayFormat: 'brackets' })

    if (mutateLocation) {
        var sp = new URLSearchParams(stringiFiedParams)
        const route = location.hash.split('?')[0]
        window.history.replaceState(null, null, `${route}?${sp.toString()}`)
    }

    return stringiFiedParams
}

const fetch = (uri, query = {}, options = {}) => {
    const trimmedUri = uri.replace(/^(.+?)\/*?$/, '$1')

    const { mutateLocation, useDev, failSilently, responseType } = options
    const { cancelToken, ...q } = query
    const axiosInstance = useDev ? http_dev : http
    return axiosInstance.get(trimmedUri, {
        cancelToken,
        params: q,
        responseType,
        paramsSerializer: (p) => paramsSerializer(p, mutateLocation),
    })
    .then(mutateResponse)
    .catch(e => handleErrorResponse(e, failSilently))
}

const del = (uri, query = {}, options = {}) => {
    const trimmedUri = uri.replace(/^(.+?)\/*?$/, '$1')

    const { mutateLocation, useDev } = options

    const { cancelToken, ...q } = query
    const axiosInstance = useDev ? http_dev : http

    return axiosInstance.delete(trimmedUri, {
        cancelToken,
        params: q,
        paramsSerializer: (p) => paramsSerializer(p, mutateLocation),
    })
    .then(mutateResponse)
    .catch(handleErrorResponse)
}

const post = (uri, body = {}, options = {}) => {
    let trimmedUri = uri.replace(/^(.+?)\/*?$/, '$1')

    const { useDev, query, ...rest } = options
    const axiosInstance = useDev ? http_dev : http

    if (query) { trimmedUri = `${trimmedUri}?${paramsSerializer(query, false)}` }
    return axiosInstance.post(trimmedUri, body, rest)
    .then(mutateResponse)
    .catch(handleErrorResponse)
}

const put = (uri, body = {}, options = {}) => {
    let trimmedUri = uri.replace(/^(.+?)\/*?$/, '$1')

    const { useDev, query } = options
    const axiosInstance = useDev ? http_dev : http

    if (query) { trimmedUri = `${trimmedUri}?${paramsSerializer(query, false)}` }
   return axiosInstance.put(trimmedUri, body)
    .then(mutateResponse)
    .catch(handleErrorResponse)
}

const patch = (uri, body = {}, options = {}) => {
    let trimmedUri = uri.replace(/^(.+?)\/*?$/, '$1')

    const { useDev, query } = options
    const axiosInstance = useDev ? http_dev : http

    if (query) { trimmedUri = `${trimmedUri}?${paramsSerializer(query, false)}` }

    return axiosInstance.patch(trimmedUri, body)
    .then(mutateResponse)
    .catch(handleErrorResponse)
}

export default {
    http,
    http_dev,
    fetch,
    post,
    put,
    del,
    patch,
    handleErrorResponse,
    mutateResponse,
}
